module.exports = __webpack_public_path__ + "07f98c09-a3b5-4ab3-a35e-9d9474d19279.169dae0e59cbfb1cf617.woff";


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/assets/fonts/07f98c09-a3b5-4ab3-a35e-9d9474d19279.woff
// module id = ../../../../../src/assets/fonts/07f98c09-a3b5-4ab3-a35e-9d9474d19279.woff
// module chunks = 2